import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Edit } from 'tabler-icons-react';
import { useNavigate } from 'react-router-dom';

import { UserRoles } from '../../components/UserRoles';

import { arrayToColumn } from '../../utils/arrayToColumn';

export const useUserListColumns = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return [
    {
      key: 'name',
      dataIndex: 'name',
      title: t('users.name'),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      key: 'email',
      dataIndex: 'email',
      title: t('users.email'),
    },
    {
      key: 'roles',
      dataIndex: 'roles',
      title: t('users.roles'),
      render: text => <UserRoles roles={text} />,
    },
    {
      key: 'companies',
      dataIndex: 'companies',
      title: t('users.companies'),
      render: text => arrayToColumn(text, 'name'),
    },
    {
      key: 'actionColumn',
      title: '',
      align: 'center',
      render: row => (
        <Button type='link' onClick={() => navigate(`/front/users/${row._id}`)}>
          <Edit />
        </Button>
      ),
    },
  ];
};
